import axios from "axios";
import { CompanyMaster } from "./company.shemas";
import { ResponseList } from "../../models/common/Response";

export async function retrieveCompanyMaster() {
    return await axios.get<ResponseList<CompanyMaster>>('/v1/company_master', {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('LG_APPLICATION'),
        }
    });
}